module.exports = __webpack_public_path__ + "static/II. Violons du Roy (DancingMasterLS (violons).67c6b44b.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/II. Violons du Roy (DancingMasterLS (violons).jpg
// module id = 885
// module chunks = 140378131144412